export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8192.85e32b88.jpg";